export default {
  // Page title
  'page.title': 'Jam Dunia',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'Waktu Lokal',
  'timezone.currentTime': 'Waktu Saat Ini',
  'timezone.label': 'Zona Waktu',
  'timezone.title': 'Zona Waktu {{city}}',
  'timezone.localClockOffset': 'Offset Jam Lokal',
  'timezone.timeZone': 'Zona waktu',
  'timezone.today': 'Hari Ini',
  'timezone.hours': 'J',
  'timezone.standardTimeZone': 'Zona Waktu Standar',
  'timezone.daylightSavingTimeZone': 'Zona Waktu Musim Panas',

  // City names (keeping English as standard)
  'city.newYork': 'New York',
  'city.london': 'London',
  'city.paris': 'Paris',
  'city.tokyo': 'Tokyo',
  'city.sydney': 'Sydney',
  'city.dubai': 'Dubai',
  'city.singapore': 'Singapore',
  'city.hongKong': 'Hong Kong',
  'city.shanghai': 'Shanghai',
  'city.beijing': 'Beijing',
  'city.mumbai': 'Mumbai',
  'city.moscow': 'Moscow',
  'city.berlin': 'Berlin',
  'city.losAngeles': 'Los Angeles',
  'city.chicago': 'Chicago',
  'city.toronto': 'Toronto',
  'city.vancouver': 'Vancouver',
  'city.brasilia': 'Brasília',
  'city.buenosAires': 'Buenos Aires',
  'city.cairo': 'Cairo',
  'city.istanbul': 'Istanbul',

  // How to use
  'howto.title': 'Cara Menggunakan Jam Dunia Online',
  'howto.step1': 'Website jam dunia ini menampilkan waktu saat ini dan waktu dunia untuk kota mana pun di seluruh dunia. Periksa zona waktu, perbedaan waktu dunia, dan waktu internasional secara instan di seluruh dunia.',
  'howto.step2': 'Halaman beranda jam dunia menampilkan waktu lokal Anda ditambah beberapa jam dunia untuk kota-kota besar. Setiap zona waktu dunia menampilkan waktu yang tepat, tanggal, dan informasi offset zona waktu.',
  'howto.step3': 'Klik nama kota mana pun dalam daftar jam dunia untuk melihat informasi zona waktu terperinci. Setiap halaman waktu dunia menyediakan data zona waktu komprehensif dan waktu saat ini untuk lokasi tersebut.',
  'howto.step4': 'Gunakan pencarian jam dunia untuk menemukan waktu di kota global mana pun. Sempurna untuk memeriksa zona waktu dunia, koordinasi waktu internasional, dan kebutuhan manajemen waktu global.',

  // User reviews
  'reviews.title': 'Ulasan Pengguna',
  'reviews.globalBusiness': 'Penting untuk bisnis internasional! Mudah mengkoordinasikan waktu rapat di berbagai zona waktu, sangat nyaman.',
  'reviews.travelBlogger': 'Harus dimiliki untuk perencanaan perjalanan! Selalu tahu waktu lokal di tujuan saya, tidak ada lagi kebingungan jet lag.',
  'reviews.remoteTeam': 'Sempurna untuk kolaborasi tim jarak jauh! Mudah melihat kapan rekan kerja di berbagai negara sedang bekerja.',
  'reviews.internationalFamily': 'Bagus untuk tetap terhubung dengan keluarga di luar negeri! Selalu tahu waktu terbaik untuk menelepon tanpa mengganggu tidur mereka.',
  'reviews.managerZhang': 'Sebagai manajer proyek, ini membantu saya menjadwalkan rapat dengan klien global lebih efektif.',

  // User names
  'user.globalBusiness': 'Global Business',
  'user.travelBlogger': 'Travel Blogger',
  'user.remoteTeam': 'Remote Developer',
  'user.internationalFamily': 'International Family',
  'user.managerZhang': 'Manager Zhang',

  // Keywords
  'keywords.worldclock': 'jam dunia zona waktu waktu internasional jam berapa',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'Waktu Berdasarkan Negara',
  'timeIn': 'Waktu di',
  'cities': 'kota',
  'available': 'tersedia',
  'citiesIn': 'Kota di',
  'viewDetails': 'Lihat detail',
  'countryNotFound': 'Negara tidak ditemukan',
  'backToWorldClock': 'Kembali ke Jam Dunia',
  'cityNotFound': 'Kota tidak ditemukan',
  'popularCitiesIn': 'Kota Populer di',
  'currentTime': 'Waktu Saat Ini',
};
